angular.module("ainapp")
    .controller("CostCenterController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Cost Center";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Profile = {};
            MainService.GetCompanyProfile().then(function (response) {
                $scope.Profile = response.data;
            })

            $scope.search = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }
            $scope.refresh = function () {
                $scope.filter = {
                    Keyword: ""
                }
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.loadKendo = function () {

                $scope.KendoSource = new kendo.data.DataSource({
                    batch: true,
                    transport: {
                        read: function (o) {
                            o.data.ParentId = $stateParams.costId;
                            o.data.Keyword = $scope.filter.Keyword;
                            MainService.GetCostCentersInKendo(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        },

                    },
                    change: function (data) {},
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                Name: {
                                    type: "string",
                                    editable: false,
                                },
                                Code: {
                                    type: "string",
                                    editable: false,
                                },
                                Address: {
                                    type: "string",
                                    editable: false,
                                },
                                Description: {
                                    type: "string",
                                    editable: false,
                                },
                                IsHide: {
                                    type: "boolean",
                                    editable: false,
                                },
                                Field1: {
                                    type: "string",
                                    editable: false,
                                },
                                Field2: {
                                    type: "string",
                                    editable: false,
                                },
                                Field3: {
                                    type: "string",
                                    editable: false,
                                },
                                Field4: {
                                    type: "string",
                                    editable: false,
                                },
                                Field5: {
                                    type: "string",
                                    editable: false,
                                },
                                Field6: {
                                    type: "string",
                                    editable: false,
                                },
                                Field7: {
                                    type: "string",
                                    editable: false,
                                },
                                Field8: {
                                    type: "string",
                                    editable: false,
                                },
                                Field9: {
                                    type: "string",
                                    editable: false,
                                },
                                Field10: {
                                    type: "string",
                                    editable: false,
                                },
                                Field11: {
                                    type: "string",
                                    editable: false,
                                },
                                Field12: {
                                    type: "string",
                                    editable: false,
                                },
                                Field13: {
                                    type: "string",
                                    editable: false,
                                },
                                Field14: {
                                    type: "string",
                                    editable: false,
                                },
                                Field15: {
                                    type: "string",
                                    editable: false,
                                },
                                Field16: {
                                    type: "string",
                                    editable: false,
                                },
                                Field17: {
                                    type: "string",
                                    editable: false,
                                },
                                Field18: {
                                    type: "string",
                                    editable: false,
                                },
                                Field19: {
                                    type: "string",
                                    editable: false,
                                },
                                Field20: {
                                    type: "string",
                                    editable: false,
                                },
                            }
                        }
                    },
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                    pageSize: 20,
                });

                $scope.KendoGridOptions = {

                    editable: false,
                    pageable: true,
                    toolbar: ["excel"],
                    height: 600,
                    resizable: true,
                    dataSource: $scope.KendoSource,
                    pageSize: 20,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    sortable: true,
                    scrollable: true,
                    filterable: true,
                    groupable: true,
                    columnMenu: {
                        filterable: false,
                        filterable: true,
                    },
                    columns: [
                        {
                            field: "Name",
                            title: "Name",
                            headerTemplate: "{{LanguageData.Name}}",
                            width: "100px"
                        },
                        {
                            field: "Code",
                            title: "Code",
                            width: "100px"
                        },
                        {
                            field: "Address",
                            title: "Address",
                            width: "100px",
                            hidden: !$scope.CostDesign.IsAddress
                        },
                        {
                            field: "Description",
                            title: "Description",
                            width: "100px",
                            hidden: !$scope.CostDesign.IsDescription
                        },
                        {
                            field: "IsHide",
                            title: "Active Status",
                            width: "100px",
                            template: "<p ng-if='dataItem.IsHide'> In-Active </p> <p ng-if='!dataItem.IsHide'> Active </p>"
                        },
                        {
                            field: "Field1",
                            title: $scope.CostDesign.Field1,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField1
                        },
                        {
                            field: "Field2",
                            title: $scope.CostDesign.Field2,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField2
                        },
                        {
                            field: "Field3",
                            title: $scope.CostDesign.Field3,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField3
                        },
                        {
                            field: "Field4",
                            title: $scope.CostDesign.Field4,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField4
                        },
                        {
                            field: "Field5",
                            title: $scope.CostDesign.Field5,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField5
                        },
                        {
                            field: "Field6",
                            title: $scope.CostDesign.Field6,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField6
                        },
                        {
                            field: "Field7",
                            title: $scope.CostDesign.Field7,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField7
                        },
                        {
                            field: "Field8",
                            title: $scope.CostDesign.Field8,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField8
                        },
                        {
                            field: "Field9",
                            title: $scope.CostDesign.Field9,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField9
                        },
                        {
                            field: "Field10",
                            title: $scope.CostDesign.Field10,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField10
                        },
                        {
                            field: "Field11",
                            title: $scope.CostDesign.Field11,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField11
                        },
                        {
                            field: "Field12",
                            title: $scope.CostDesign.Field12,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField12
                        },
                        {
                            field: "Field13",
                            title: $scope.CostDesign.Field13,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField13
                        },
                        {
                            field: "Field14",
                            title: $scope.CostDesign.Field14,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField14
                        },
                        {
                            field: "Field15",
                            title: $scope.CostDesign.Field15,
                            width: "100px",
                            hidden: !$scope.CostDesign.IsField15
                        },
                        {
                            field: "Field16",
                            title: $scope.CostDesign.Field16,
                            width: "100px",
                            template: "<p>{{dataItem.Field16 | date:'dd/MM/yyyy'}}</p>",
                            hidden: !$scope.CostDesign.IsField16
                        },
                        {
                            field: "Field17",
                            title: $scope.CostDesign.Field17,
                            width: "100px",
                            template: "<p>{{dataItem.Field17 | date:'dd/MM/yyyy'}}</p>",
                            hidden: !$scope.CostDesign.IsField17
                        },
                        {
                            field: "Field18",
                            title: $scope.CostDesign.Field18,
                            width: "100px",
                            template: "<p>{{dataItem.Field18 | date:'dd/MM/yyyy'}}</p>",
                            hidden: !$scope.CostDesign.IsField18
                        },
                        {
                            field: "Field19",
                            title: $scope.CostDesign.Field19,
                            width: "100px",
                            template: "<p>{{dataItem.Field19 | date:'dd/MM/yyyy'}}</p>",
                            hidden: !$scope.CostDesign.IsField19
                        },
                        {
                            field: "Field20",
                            title: $scope.CostDesign.Field20,
                            width: "100px",
                            template: "<p>{{dataItem.Field20 | date:'dd/MM/yyyy'}}</p>",
                            hidden: !$scope.CostDesign.IsField20
                        },
                        {
                            title: "Options",
                            headerTemplate: "{{LanguageData.Options}}  ",
                            template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                            width: '80px'
                        },
                    ],
                };

            }


            $scope.Init = function () {

                $scope.VoucherDocs = [];
                $scope.filter = {
                    Keyword: ""
                }

                $scope.ViewVal = 0;
                $scope.GroupName = $stateParams.costName;

                $scope.CostDesign = {};
                MainService.GetCostCenterDesign($stateParams.costId).then(function (response) {
                    if (response.data != null) {
                        $scope.CostDesign = response.data;
                    } else {
                        $scope.CostDesign = {};
                    }

                    $scope.CurrentCostCenter = {
                        Name: "",
                        Level: 2,
                        Description: "",
                        Address: "",
                        ParentId: $state.costId,
                        Code: "",
                        IsActive: true,
                        Field1: "",
                        Field2: "",
                        Field3: "",
                        Field4: "",
                        Field5: "",
                        Field6: "",
                        Field7: "",
                        Field8: "",
                        Field9: "",
                        Field10: "",
                        Field11: "",
                        Field12: "",
                        Field13: "",
                        Field14: "",
                        Field15: "",
                        Field16: null,
                        Field17: null,
                        Field18: null,
                        Field19: null,
                        Field20: null,
                    }

                    if ($scope.CostDesign.IsAutoCode) {

                        MainService.GetNextCoseCenterNo($stateParams.costName).then(function (response) {
                            $scope.CurrentCostCenter.Code = response.data;
                        })

                    }

                    $scope.loadKendo();

                    $scope.load = false;
                }, function (err) {
                    $scope.load = false;
                });

                $scope.SelectedGroup = {
                    Name: $stateParams.costName,
                    Id: $stateParams.costId
                };

                $scope.load = 0;
            }
            $scope.Init();


            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteCostCenter($scope.SelectedDataForDelete.Id, 1).then(function (response) {
                    if (response.data == "Success") {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    } else {
                        toastr.error(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }


            $scope.Edit = function (data) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.CostCenterById(data.Id).then(function (response) {
                    if (response.data != null) {

                        $scope.CurrentCostCenter = response.data;

                        if ($scope.CurrentCostCenter.Field16 != null && $scope.CurrentCostCenter.Field16 != undefined && $scope.CurrentCostCenter.Field16 != "") {
                            $scope.CurrentCostCenter.Field16 = new Date($scope.CurrentCostCenter.Field16);
                        }
                        if ($scope.CurrentCostCenter.Field17 != null && $scope.CurrentCostCenter.Field17 != undefined && $scope.CurrentCostCenter.Field17 != "") {
                            $scope.CurrentCostCenter.Field17 = new Date($scope.CurrentCostCenter.Field17);
                        }
                        if ($scope.CurrentCostCenter.Field18 != null && $scope.CurrentCostCenter.Field18 != undefined && $scope.CurrentCostCenter.Field18 != "") {
                            $scope.CurrentCostCenter.Field18 = new Date($scope.CurrentCostCenter.Field18);
                        }
                        if ($scope.CurrentCostCenter.Field19 != null && $scope.CurrentCostCenter.Field19 != undefined && $scope.CurrentCostCenter.Field19 != "") {
                            $scope.CurrentCostCenter.Field19 = new Date($scope.CurrentCostCenter.Field19);
                        }
                        if ($scope.CurrentCostCenter.Field20 != null && $scope.CurrentCostCenter.Field20 != undefined && $scope.CurrentCostCenter.Field20 != "") {
                            $scope.CurrentCostCenter.Field20 = new Date($scope.CurrentCostCenter.Field20);
                        }

                        $scope.VoucherDocs = response.data.VoucherDocs;

                    } else {
                        toastr.error("Network Error");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });



            }


            $scope.saveCostCenter = function () {

                if ($scope.CurrentCostCenter.Name == "") {
                    toastr.warning("Give Cost Center Name");
                } else if ($scope.CurrentCostCenter.Code == "") {
                    toastr.warning("Give Cost Center Code");
                } else if ($scope.CurrentCostCenter.Description == "" && $scope.CostDesign.IsDescriptionMandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter Description");
                } else if ($scope.CurrentCostCenter.Address == "" && $scope.CostDesign.IsAddressMandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter Address");
                } else if ($scope.CurrentCostCenter.Field1 == "" && $scope.CostDesign.IsField1Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field1);
                } else if ($scope.CurrentCostCenter.Field2 == "" && $scope.CostDesign.IsField2Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field2);
                } else if ($scope.CurrentCostCenter.Field3 == "" && $scope.CostDesign.IsField3Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field3);
                } else if ($scope.CurrentCostCenter.Field4 == "" && $scope.CostDesign.IsField4Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field4);
                } else if ($scope.CurrentCostCenter.Field5 == "" && $scope.CostDesign.IsField5Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field5);
                } else if ($scope.CurrentCostCenter.Field6 == "" && $scope.CostDesign.IsField6Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field6);
                } else if ($scope.CurrentCostCenter.Field7 == "" && $scope.CostDesign.IsField7Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field7);
                } else if ($scope.CurrentCostCenter.Field8 == "" && $scope.CostDesign.IsField8Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field8);
                } else if ($scope.CurrentCostCenter.Field9 == "" && $scope.CostDesign.IsField9Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field9);
                } else if ($scope.CurrentCostCenter.Field10 == "" && $scope.CostDesign.IsField10Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field10);
                } else if ($scope.CurrentCostCenter.Field11 == "" && $scope.CostDesign.IsField11Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field11);
                } else if ($scope.CurrentCostCenter.Field12 == "" && $scope.CostDesign.IsField12Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field12);
                } else if ($scope.CurrentCostCenter.Field13 == "" && $scope.CostDesign.IsField13Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field13);
                } else if ($scope.CurrentCostCenter.Field14 == "" && $scope.CostDesign.IsField14Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field14);
                } else if ($scope.CurrentCostCenter.Field15 == "" && $scope.CostDesign.IsField15Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field15);
                } else if ($scope.CurrentCostCenter.Field16 == null && $scope.CostDesign.IsField16Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field16);
                } else if ($scope.CurrentCostCenter.Field17 == null && $scope.CostDesign.IsField17Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field17);
                } else if ($scope.CurrentCostCenter.Field18 == null && $scope.CostDesign.IsField18Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field18);
                } else if ($scope.CurrentCostCenter.Field19 == null && $scope.CostDesign.IsField19Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field19);
                } else if ($scope.CurrentCostCenter.Field20 == null && $scope.CostDesign.IsField20Mandatory && $scope.CurrentCostCenter.ParentId > 0) {
                    toastr.warning("Enter " + $scope.CostDesign.Field20);
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    $scope.CurrentCostCenter.VoucherDocs = $scope.VoucherDocs;
                    $scope.CurrentCostCenter.ParentId = $stateParams.costId;

                    MainService.AddCostCenter($scope.CurrentCostCenter).then(function (response) {
                        $scope.load = false;
                        if (response.data == "Success") {
                            toastr.success("Cost Center Saved");
                            $("#addCostModal").modal("hide");
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            $scope.Init();
                        } else {
                            toastr.error(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $scope.load = false;
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }

            }



            /////////////////// EXTRA AUTO COMPLETE //////////////////

            $scope.FieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.CostcenterFieldAutoComplete(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.FieldAutoCompleteOptions11 = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCostCenter.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };

            $scope.FieldAutoCompleteOptions12 = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCostCenter.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };

            $scope.FieldAutoCompleteOptions13 = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCostCenter.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };

            $scope.FieldAutoCompleteOptions14 = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCostCenter.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };

            $scope.FieldAutoCompleteOptions15 = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentCostCenter.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };



            /////////////////// Attachment //////////////////

            $scope.VoucherDocs = [];
            $scope.initAttachment = function () {
                $scope.VAttachment = {
                    ExpiryDate: null,
                    FileName: "",
                    FilePath: "",
                    Remarks: "",
                    IsActive: true,
                }
            }
            $scope.initAttachment();

            $scope.addAttachmentList = function () {
                if ($scope.VAttachment.FilePath == "") {
                    toastr.warning("Upload File");
                } else if ($scope.VAttachment.FileName == "") {
                    toastr.warning("Enter File Name");
                } else {
                    $scope.VoucherDocs.push($scope.VAttachment);
                    $scope.initAttachment();
                }
            }

            $scope.removeAttachmentRow = function (data) {
                data.IsActive = false;
            }


            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i])
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            }
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.VAttachment.FilePath = objXhr.responseText;
                            if ($scope.VAttachment.FilePath.includes("error")) {
                                $scope.VAttachment.FilePath = "";
                                toastr.error($scope.LanguageData.UploadError);
                            } else {
                                //$scope.VAttachment.FilePath = objXhr.responseText;
                                $scope.VAttachment.FilePath = objXhr.responseText;
                                toastr.success($scope.LanguageData.FileUploaded);
                            }
                        } else {

                        }
                    }
                }
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info($scope.LanguageData.FileUploadingPleaseWait);
                    objXhr.open("POST", config.basePath + "UploadFiles");
                    objXhr.send(data);
                } else {
                    toastr.error($scope.LanguageData.UploadError);
                }
            }
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }


                }])
